const imageBasePath =
  process.env.NODE_ENV === "development" ? `http://localhost:7011` : `https://api.shoppingkori.com.bd`;

// const imageBasePath = `https://api.sellmart.com.bd`;

export default imageBasePath;
